package games.polyclub.website.frontend.store.pages.aof7

import games.polyclub.frontend.lib.react.bootstrap.components.Card
import games.polyclub.frontend.lib.react.bootstrap.components.CardTabs
import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.new
import games.polyclub.frontend.lib.react.simplified.tags.div
import games.polyclub.frontend.lib.react.simplified.tags.h3
import games.polyclub.frontend.lib.react.simplified.tags.p
import games.polyclub.frontend.lib.react.simplified.tags.strong
import games.polyclub.frontend.lib.react.utils.classes
import games.polyclub.message.unaryMinus
import games.polyclub.service.payment.api.id.OfferId
import games.polyclub.service.payment.api.id.ProductId
import games.polyclub.website.frontend.store.components.ProductPurchaseForm
import games.polyclub.website.frontend.store.context.addBreadcrumb
import games.polyclub.website.frontend.store.layout.PageBody
import games.polyclub.website.frontend.store.layout.PageHeader
import games.polyclub.website.frontend.store.pages.product.AccessPassInfo
import games.polyclub.website.frontend.store.pages.product.OriginalMinecraft
import games.polyclub.website.frontend.store.sitemap.PublicSitemap
import react.Props

val AllOfFabric7Page = SFC<Props> { _ ->
    addBreadcrumb(PublicSitemap.AOF7.pathPart, -"GameMods: All Of Fabric 7")

    PageHeader {
        title = -"GameMods: All Of Fabric 7"
        titleIcon = PublicSitemap.AOF7.icon
    }
    PageBody {
        Card {
            div("row") {
                div("col-12 col-sm-6") {
                    h3("d-inline-block d-sm-none") {
                        +"GameMods: All Of Fabric 7"
                    }
                    AOF7Images()
                }
                ProductPurchaseForm {
                    offerId = OfferId("accessPass.aof7.beta")
                    mainProduct = ProductId.ALL_OF_FABRIC_ACCESS_PASS
                    title = h3.new {
                        classes = "my-3"
                        with(PublicSitemap.AOF7.icon!!) {
                            renderIcon()
                        }
                        +Typography.nbsp
                        +"Passe de Acesso do GameMods: All Of Fabric 7"
                    }
                    shortDescription = p.new {
                        strong { +"All Of Fabric" }
                        +" é um modpack open world, ou seja, você pode fazer o que quiser, não há um objetivo final. Você pode explorar o mundo, construir, fazer farms, automatizar tudo, etc."
                    }
                }
            }
            CardTabs("card-primary mt-4") {
                +"Passe de Acesso"
                AccessPassInfo()
                +"Como Instalar"
                AOF7HowToInstall()
                +"Como Jogar"
                AOF7HowToPlay()
                +"Minecraft Original"
                OriginalMinecraft()
            }
        }
    }
}
